export const REMOTE_TRACKING_TIMEOUT = 2 * 60 * 1000; // 2 minutes
export const RETRY_IMPORT_REMOTE = 'retry-import-remote';
export const EXO_SKELETON_SCOPE_NAME = 'ACCExoSkeleton';
export const REMOTE_MODULE_ERROR = 'remote-module-error';
//# sourceMappingURL=consts.js.map